import './JobLine.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowsH,
  faBars,
  faCircleExclamation,
  faCube,
  faCutlery,
  faFlask,
  faSnowflake,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';

// General JobLine Component
const JobLine = ({ assignment, packages, setDisplayAssignment, unexpected, movementType }) => {
  const actQuantityPackages = packages && packages?.length;
  const actQuantityItems =
    packages && packages?.map(pkg => pkg?.quantity).reduce((a, b) => a + b, 0);
  const actType =
    packages && packages[0]?.packageType?.shortName
      ? packages?.every(pkg => pkg?.packageType?.shortName == packages[0]?.packageType?.shortName)
        ? packages[0]?.packageType?.shortName
        : 'pkg'
      : 'pkg';

  const actWeight = packages && packages?.map(pkg => pkg?.grossWeightKg).reduce((a, b) => a + b, 0);
  const expVolume = Number(assignment?.cubicMetres || 0).toFixed(2);
  const actVolume =
    packages &&
    packages
      ?.map(pkg => Number(pkg?.cubicMetres || 0))
      .reduce((a, b) => a + b, 0)
      .toFixed(2);

  const hazardous = assignment?.job?.cargoHazardous;
  const doNotStack = assignment?.job?.doNotStack;
  const fullLoad = assignment?.job?.fullLoad;
  const waste = assignment?.job?.commodityCategory?.waste;
  const foodstuffs = assignment?.job?.commodityCategory?.foodstuffs;
  const temperatureControlled = assignment?.job?.temperatureControlled;
  const overlength = assignment?.job?.overlength;
  const mustLoad = assignment?.mustLoad;

  const getCompleteStatus = () => {
    if (unexpected) {
      return 'Unexpected';
    } else if (movementType == 'imports') {
      if (actQuantityPackages > assignment.quantity) {
        return 'Overcomplete';
      } else if (actQuantityPackages == assignment.quantity) {
        return 'Present';
      } else if (!actQuantityPackages) {
        return 'Missing';
      } else {
        return 'Incomplete';
      }
    } else {
      if (actQuantityPackages >= assignment.quantity) {
        return 'Loaded';
      } else if (!actQuantityPackages) {
        return 'Ready';
      } else {
        return 'Loading';
      }
    }
  };

  return (
    <div
      className={`job_line_container ${getCompleteStatus()}`}
      onClick={() => setDisplayAssignment(assignment)}
    >
      <div className="job_line_row">
        <div className="job_line_reference">{assignment?.job?.jobReference}</div>
        <div className="job_line_consignee">{assignment?.job?.consignee?.name}</div>
        <div className="job_line_quantity_type">
          Expected: {assignment?.quantity || 0} {assignment?.job?.packageType?.shortName || 'pkg'}
          (s)
        </div>
        <div className="job_line_weight">{assignment?.grossWeightKg || 0} kg</div>
        <div className="job_line_cubic_metres">{expVolume}m³</div>
      </div>

      <div className="job_line_row">
        <div className="job_line_symbol_row">
          {hazardous && (
            <div className="job_line_symbol hazardous">
              <FontAwesomeIcon icon={faFlask} data-testid="hazard_icon" />
            </div>
          )}
          {mustLoad && (
            <div className="job_line_symbol must_load">
              <FontAwesomeIcon icon={faCircleExclamation} data-testid="must_load_icon" />
            </div>
          )}
          {fullLoad && (
            <div className="job_line_symbol full_load">
              <FontAwesomeIcon icon={faCube} data-testid="full_load_icon" />
            </div>
          )}
          {doNotStack && (
            <div className="job_line_symbol do_not_stack">
              <FontAwesomeIcon icon={faBars} data-testid="do_not_stack_icon" />
            </div>
          )}
          {foodstuffs && (
            <div className="job_line_symbol foodstuffs">
              <FontAwesomeIcon icon={faCutlery} data-testid="foodstuffs_icon" />
            </div>
          )}
          {temperatureControlled && (
            <div className="job_line_symbol temp_control">
              <FontAwesomeIcon icon={faSnowflake} data-testid="temperature_icon" />
            </div>
          )}
          {waste && (
            <div className="job_line_symbol waste">
              <FontAwesomeIcon icon={faTrash} data-testid="waste_icon" />
            </div>
          )}
          {overlength && (
            <div className="job_line_symbol overlength">
              <FontAwesomeIcon icon={faArrowsH} data-testid="overlength_icon" />
            </div>
          )}
        </div>
        <div className="job_line_marks_line_2">{assignment?.job?.marksLine2}</div>
        <div className="job_line_quantity_type">
          Actual: {actQuantityPackages || 0} {actType}
          {'(s) '}
          {actQuantityItems != actQuantityPackages ? `(${actQuantityItems} items)` : ''}
        </div>
        <div className="job_line_weight">{actWeight || 0} kg</div>
        <div className="job_line_cubic_metres">{actVolume}m³</div>
      </div>
      <div className={`status_indicator ${getCompleteStatus()}`}>{getCompleteStatus()}</div>
    </div>
  );
};

JobLine.propTypes = {
  assignment: PropTypes.object,
  packages: PropTypes.array,
  setDisplayAssignment: PropTypes.func,
  unexpected: PropTypes.bool,
  movementType: PropTypes.string,
};

export default JobLine;
